import App from "components/App"
import Loading from "components/loading"
import ViewOnlyToast from "components/ViewOnlyToast"
import { useCustomerData } from "context/customer-provider"
import { useFetchSetup } from "hooks/useFetchSetup"
import { useIntercomScript } from "hooks/useIntercomScript"

const AppWrapper = () => {
  const {
    customerId,
    customerData,
    isAuthenticated,
    auth0IsLoading,
    customerDataIsLoading,
    customerDataError,
    profileSettled,
  } = useCustomerData()

  const { fetchReady } = useFetchSetup()

  // Boots the Intercom messenger; not something the app waits for.
  useIntercomScript()

  if (auth0IsLoading) return <Loading text="Setting up..." />
  if (!isAuthenticated) return <Loading text="Authenticating..." />
  if (!customerId) return <Loading text="Getting User Info..." />
  if (customerDataIsLoading) return <Loading text="Resolving customer products..." />
  // Fetched alongside the customer requests, so normally already settled here.
  if (!profileSettled) return <Loading text="Getting User Info..." />
  if (!fetchReady) return <Loading text="Enabling network..." />

  if (customerDataError) {
    return (
      <>
        <Loading text={customerDataError.message} className="text-danger" />
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <pre>This error has been logged and will be investigated.</pre>
        </div>
      </>
    )
  }

  if (customerData && fetchReady) {
    return (
      <>
        <App />
        <ViewOnlyToast />
      </>
    )
  }

  // fallback?!
  return <Loading />
}

export default AppWrapper
